import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  count: number;
  entity: string; // "creator", "work", "organization"
  busy?: boolean;
};

/** Confirm dialog used by the bulk-delete affordance on list pages. */
export default function ConfirmDeleteDialog({
  isOpen,
  onClose,
  onConfirm,
  count,
  entity,
  busy = false,
}: Props) {
  const cancelRef = useRef<HTMLButtonElement | null>(null);
  const noun = count === 1 ? entity : `${entity}s`;
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete {count} {noun}
          </AlertDialogHeader>
          <AlertDialogBody>
            You are about to delete {count} {noun}, are you sure?
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={busy}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              ml={3}
              onClick={onConfirm}
              isLoading={busy}
            >
              Yes, I'm sure
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
